export const AccountApi = {
  startLogin: 'admin/start-login',
  completeLogin: 'admin/complete-login',
  dashboard: 'admin/dashboard',
  signup: 'admin/register',
  adminUserList: 'account/admin',
  updateProfile: 'account/update-profile',
  changePassword: 'account/change-password',
  requestPasswordReset: 'account/forgot-password',
  resetPassword: 'account/reset-password',
};

export const AdminAccountApi = {
  base: 'staff',
  activate: 'staff/activate',
  deactivate: 'staff/deactivate',
  changePasword: 'staff/reset-password',
  updatePermissions: 'staff/permissions',
};

export const SettlmentApi = {
  bankList: 'settlement/bank-list',
  resolveBank: 'settlement/account/name-enquiry',
  settlementAccounts: 'settlement/account',
  settlementReport: 'settlement/report',
  settlementPayouts: 'settlement/payouts',
  createSettlementAccount: 'settlement/account',
  settlementTransactions: 'settlement/transaction',
  toggleVisibilty: 'settlement/toggle-visibility',
  analytics: 'settlement/analytics',
  requeryStatus: 'settlement/payout-status',
  generateSettlementReport: 'settlement/generate-report',
  singleSettlementPayout: 'settlement/payout-single',
  initManualSettlementPayout: 'settlement/init-manual-payout',
  confirmManualSettlementPayout: 'settlement/confirm-manual-payout',
  initSendMoney: 'settlement/init-send-money',
  confirmSendMoney: 'settlement/confirm-send-money',
};

export const FeesApi = {
  base: 'fees',
  createFee: 'fees',
  getFees: 'fees',
  getPaymentPeriods: 'fees/payment-periods',
  addSettlementAccount: 'settlement/account/name-enquiry',
  removeSettlementAccount: 'settlement/account',
  analyticsSummary: 'analytics',
  analyticsDetail: 'analytics/detail',
};

export const MemberApi = {
  getMembers: 'user/list',
  getUserBase: 'user/',
};

export const CustomerApi = {
  createUser: 'customers',
  getUsers: 'customers',
  addPaymentPlan: 'customers/add-payment-plan',
  userPaymentPlan: 'customers/payment-plan',
  userPaymentSchedule: 'customers/payment-schedule',
  createVariation: 'customers/schedule/discount',
  applyWaiver: 'customers/schedule/waiver',
  subGroups: 'customers/sub-group/all',
  createSubGroup: 'customers/sub-group/create',
};

export const PaymentApi = {
  getInvoiceTransactions: 'payment/all-invoice',
  getTransferTransactions: 'payment/transactions',
  wallet: 'payment/wallet',

  demandNotice: 'payment/demand-notice',
  downloadInvoice: 'payment/invoice/download',
  downloadReceipt: 'payment/receipt/download',
  getTransfers: 'payment/transfer-transactions',
  getVirtualAccounts: 'payment/virtual-accounts',
  approveInvoice: 'payment/invoice/approve',
  splitTransferAmount: 'payment/invoice/split-transfer',
  assignInvoiceTransfer: 'payment/invoice/assign-transfer',
  cancelInvoice: 'payment/invoice/cancel',
  searchInvoiceToAssign: 'payment/invoice/search-to-assign',
  associatedInvoicesByTrf: 'payment/transfer/associated-invoices',
  associatedInvoicesByAccNo: 'payment/invoice/account-number',
  associatedTransferByInv: 'payment/invoice/associated-transfers',
  dispute: 'payment/dispute',
  analytics: 'payment/analytics',
  payouts: 'payment/payouts',
  walletBalance: 'payment/wallet-balance',
  initRefund: 'payment/transfer/init-refund',
  refundTransfer: 'payment/transfer/confirm-refund',
  addTransfer: 'payment/transfer/add',
  initSendMoney: 'payment/init-send-money',
  confirmSendMoney: 'payment/confirm-send-money',
};

export const DashboardApi = {
  summary: 'business/dashboard-summary',
};

export const BusinessApi = {
  create: 'business/create-business',
  allBusiness: 'business/all',
  businessById: 'business/by-id',
};

export const ConfigApi = {
  domain: 'config/domain',
  fileUpload: 'config/file-upload',
  approve: 'config/approve',
  disable: 'config/disable',
  verifyAccount: 'payment/verify-account-number',
};
